import cn from 'classnames';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { EditableSettings } from 'components/EditableSettings/EditableSettings';
import { Button, Input, InputGroup, Textarea, ToggleSwitch } from 'components/FormComponents';

export const Emails = ({
  register,
  control,
  readOnly = false,
  backgroundColor = 'background-secondary',
  sendCandidateEmailPreview = () => {},
  sendRefereeEmailPreview = () => {},
}) => {
  const { t } = useTranslation();

  const emailActiveValue = useWatch({ control, name: 'email_active' });
  const emailCandidateActiveValue = useWatch({ control, name: 'email_candidate_active' });
  const emailRefereeActiveValue = useWatch({ control, name: 'email_referee_active' });
  const smsActiveValue = useWatch({ control, name: 'sms_active' });
  const smsCandidateActiveValue = useWatch({ control, name: 'sms_candidate_active' });
  const smsRefereeActiveValue = useWatch({ control, name: 'sms_referee_active' });

  return (
    <div className={cn('u-padding', backgroundColor)}>
      <div className={cn('card', !readOnly ? 'card-with-border u-padding' : '')}>
        <div className="u-margin-bottom">
          <InputGroup>
            <ToggleSwitch
              register={register}
              name="use_email_communication"
              label={t('company.tabs.branding.emails.useEmailCommunication')}
            />
          </InputGroup>

          <InputGroup>
            <ToggleSwitch
              register={register}
              name="use_sms_communication"
              label={t('company.tabs.branding.emails.useSmsCommunication')}
            />
          </InputGroup>
        </div>

        <EditableSettings
          title={t('company.tabs.branding.emails.useCustomizedEmails')}
          open={emailActiveValue}
          toggleable
          register={register}
          name="email_active"
          className="u-margin-bottom">
          <EditableSettings
            title={t('company.tabs.branding.emails.useCustomizedEmailsForCandidate')}
            open={emailCandidateActiveValue}
            toggleable
            register={register}
            name="email_candidate_active">
            <InputGroup title={t('company.tabs.branding.emails.subject')}>
              <Input
                register={register}
                name="email_candidate_subject"
                placeholder={t('company.tabs.branding.emails.emailCandidateSubjectPlaceholder')}
              />
            </InputGroup>

            <InputGroup title={t('company.tabs.branding.emails.body')}>
              <Textarea
                name="email_candidate_copy"
                register={register}
                placeholder={t('company.tabs.branding.emails.emailCandidateBodyPlaceholder')}
                inputProps={{ rows: 10 }}
              />
            </InputGroup>

            <div className={cn('u-flex-box', 'u-width-100', 'u-flex-justify-end')}>
              <Button
                type="secondary"
                className="u-margin-bottom--small"
                onClick={sendCandidateEmailPreview}>
                {t('company.tabs.branding.emails.previewCandidateEmail')}
              </Button>
            </div>
          </EditableSettings>

          <EditableSettings
            title={t('company.tabs.branding.emails.useCustomizedEmailsForReferee')}
            open={emailRefereeActiveValue}
            toggleable
            register={register}
            name="email_referee_active">
            <InputGroup title={t('company.tabs.branding.emails.subject')}>
              <Input
                register={register}
                name="email_referee_subject"
                placeholder={t('company.tabs.branding.emails.emailRefereeSubjectPlaceholder')}
              />
            </InputGroup>
            <InputGroup title={t('company.tabs.branding.emails.body')}>
              <Textarea
                name="email_referee_copy"
                register={register}
                placeholder={t('company.tabs.branding.emails.emailRefereeBodyPlaceholder')}
                inputProps={{ rows: 10 }}
              />
            </InputGroup>

            <div className={cn('u-flex-box', 'u-width-100', 'u-flex-justify-end')}>
              <Button
                type="secondary"
                className="u-margin-bottom--small"
                onClick={sendRefereeEmailPreview}>
                {t('company.tabs.branding.emails.previewRefereeEmail')}
              </Button>
            </div>
          </EditableSettings>
        </EditableSettings>

        <EditableSettings
          title={t('company.tabs.branding.emails.useCustomizedSms')}
          open={smsActiveValue}
          toggleable
          register={register}
          name="sms_active"
          className="u-margin-bottom">
          <EditableSettings
            title={t('company.tabs.branding.emails.useCustomizedSmsForCandidate')}
            className="u-margin-bottom"
            open={smsCandidateActiveValue}
            toggleable
            register={register}
            name="sms_candidate_active">
            <InputGroup title={t('company.tabs.branding.emails.body')}>
              <Textarea
                name="sms_candidate_copy"
                register={register}
                placeholder={t('company.tabs.branding.emails.smsCandidateBodyPlaceholder')}
                inputProps={{ rows: 10 }}
              />
            </InputGroup>
          </EditableSettings>

          <EditableSettings
            title={t('company.tabs.branding.emails.useCustomizedSmsForReferee')}
            open={smsRefereeActiveValue}
            toggleable
            register={register}
            name="sms_referee_active">
            <InputGroup title={t('company.tabs.branding.emails.body')}>
              <Textarea
                name="sms_referee_copy"
                register={register}
                placeholder={t('company.tabs.branding.emails.smsRefereeBodyPlaceholder')}
                inputProps={{ rows: 10 }}
              />
            </InputGroup>
          </EditableSettings>
        </EditableSettings>
      </div>
    </div>
  );
};
